/* eslint-disable no-console */
<template>
    <pm-simple-component-layout :toolbar-back="toolbarBack">

            <template slot="title">
                {{ $t('support.send_feedback') }}
            </template>




                <div style="padding: 30px 20px 20px 20px;">
                    <!--div style="text-align: center"><svg-comment style="margin: 20px; width: 150px; max-width: 40vw;"/></div-->
                    <v-text-field style="--delay: 50ms" class="pm-animation-fade-in-slide-down" id="feedback-email-input" outline v-model="email" :placeholder="$t('support.email')" />

                    <v-textarea style="--delay: 100ms" class="pm-animation-fade-in-slide-down" id="feedback-textarea"
                            :placeholder="$t('support.feedback')"
                            outline
                            name="feedback"
                            v-model="text"
                            hide-details
                    ></v-textarea>

                    <div class="pm-animation-fade-in-slide-down" style="--delay: 150ms; text-align: center; padding: 10px 0; margin-top: 6px;">
                        <v-btn class="roboto f13 black--text bold--text" flat style="margin: 0; height: auto; border: 2px solid rgb(41, 121, 255); padding: 4px 16px; border-radius: 24px; margin-top: 0px;" @click="sendFeedback">
                            <v-icon style="margin-right: 8px;">
                                check
                            </v-icon>{{ $t('support.send_feedback') }}
                        </v-btn>
                    </div>

                </div>

    </pm-simple-component-layout>
</template>

<style>
    #feedback-email-input {
        margin-top: 8px!important;
    }
    #feedback-phone-input {
        margin-top: 8px!important;
    }
    #feedback-textarea {
        margin-top: 10px;
    }
    .feedback-topic-select-menu .v-subheader {
        background: #eee;
        color: #000;
        font-weight: 600;
    }
    .feedback-topic-select-menu .v-list {
        padding: 0;
    }
</style>

<script>
import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";
import { getUserData } from "@/utils/user/user-data";
// import SvgComment from "../svg/comment";
export default {
    components: {
        PmSimpleComponentLayout,
        // SvgComment,
    },
    data: () => {
        return ({
            topic: 'General',
            text: '',
            email: '',
            prevRoute: '/',
        });
    },
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmailSend", this.email);
        },
    },

    created() {
        this.email = localStorage.getItem("userEmailSend") || localStorage.getItem("userEmail") || "";
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },

    methods: {
        toolbarBack() {
            this.$router.push(this.prevRoute);
        },
        sendFeedback() {
            if (this.text === "") return;
            if (this.email === "") return;

            this.callSlackWebhook();
        },

        getClientData() {
            try {
                const debug = getUserData();
                // debug.iap = JSON.stringify(window.IAP.products);

                let text = "\n```";
                Object.keys(debug).forEach((key) => {
                    text += " - " + key + ": " + debug[key] + "\n";
                });
                text += "```";

                return text;
            } catch(error) {
                captureException(error);
                return "";
            }
        },

        onFinish() {
            this.$bus.$emit("app.showSnackbar", {text: "Thank you for your feedback."});
            this.text = "";
            this.email = "";
        },

        callSlackWebhook() {
            const text = "*" + this.topic + "*\n" + this.text + "\n\n" + this.getClientData();

            this.onFinish();

            fetch("https://hooks.slack.com/services/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", {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                "body": JSON.stringify({
                        "username": "DentiCalc app feedback",
                        "icon_url": "https://public.app.denticalc.com/images/denti_calc_icon.png",
                        "text": text,
                        "channel": "#denticalc-feedback",
                    }),
                })
                .then(console.log)
                .catch(captureException);
        },
    },
};
</script>
